module.exports = __webpack_public_path__ + "static/media/cat-8.da335fed.jpg";